import React from 'react';
import { Modal } from 'carbon-components-react';
import { VideoPlayer } from '@symposium/ui-react/es';

const Overlay = ({ handler, ariaLabel, thumb }) => {
  return (
    <>
      <Modal aria-label={ariaLabel} open={handler} onRequestClose={handler} size='lg' passiveModal>
        <div>
          <VideoPlayer
            className='om-p--442'
            thumbnailUrl={thumb}
            initialized
            playing
            url='https://youtu.be/8CUkZ2-LSfY'
            key='youtube'
            height='100%'
            width='100%'
          />
        </div>
      </Modal>
    </>
  );
};
export default Overlay;
